import React, { useEffect, useState, startTransition } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Typography,
  Box,
  Button,
  Paper,
  Card,
  CardContent,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Snackbar,
  Alert,
  FormLabel,
  FormGroup,
  Checkbox,
  LinearProgress,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "react-quill/dist/quill.snow.css";
import {
  getContactDossier,
  postContactDossierStep,
  postContactDossierFinal,
} from "../ContactDossier/Network_call";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const personalityAttributes = [
  "Visionary",
  "Innovative",
  "Quick to Respond",
  "Easy to Reach",
  "Growth Mindset",
  "Open to Ideas",
  "Risk Taker",
  "Engaging in Discussions",
  "Timely Payments",
  "Ready to be a Reference",
  "Business Only",
  "Quick Decision Maker",
];

const valuesList = [
  "Trust",
  "Relationship",
  "Transparency",
  "Timely Response",
  "High Quality Products/Services",
  "Admit Mistakes/Failures",
  "Closing the Loop",
  "Inform Proactively (even if bad news)",
];

const relationshipOptionsForEmployee = [
  "Colleague",
  "Ex-Colleague",
  "Customer",
  "Partner",
  "Classmate",
  "Friend",
  "Relation",
  "Vendor/Supplier",
  "Connection of Connection",
];

const respondsWellToOptions = [
  "Email",
  "Phone Calls",
  "SMS/WhatsApp",
  "LinkedIn Messages",
  "In Person Meeting Requests",
];

const ContactDossier = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { journey_type } = useParams();
  const [dossierData, setDossierData] = useState(null);
  const [err, setErr] = useState(false);
  const [name, setName] = useState("");
  const [implId, setImplId] = useState("");
  const [id, setId] = useState("");
  const [loadingDossier, setLoadingDossier] = useState(false);

  const initialFormState = {
    levelOfInfluence: "",
    companiesAssociated: "",
    desiredRelationshipLevel: "",
    relationshipNote: "", 
    employees: [],
    respondsWellTo: [],
    respondsWellToOther: "",
    personality: personalityAttributes.reduce((acc, attr) => ({ ...acc, [attr]: "" }), {}),
    values: [],
    valuesOther: "",
    upsellLikelihood: null,
    upsellTimeline: "",
    attributesNote: "",
  };

  const [form, setForm] = useState(initialFormState);
  const [originalForm, setOriginalForm] = useState(null); 
  const [formErrors, setFormErrors] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, severity: "success", msg: "" });

  const [step, setStep] = useState(0);
  const [progressPercent, setProgressPercent] = useState(0);
  const [savedSteps, setSavedSteps] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);

  const influenceOptions = [
    "Sole Decision Maker",
    "One of the Decision Makers",
    "Strong Influencer",
    "Not an Influencer",
    "Not Sure",
  ];

  const relationshipLevelOptions = [
    "Avoid",
    "Respond only if Contact Reaches Out",
    "Engage as needed for Business",
    "Have Regular Connects",
    "Connect Multiple Times in a Week",
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setName(params.get("name") || "");
    setImplId(params.get("impl_id") || "");
    setId(params.get("id") || "");
  }, [location.search]);

  const contactDisplayText = React.useMemo(() => {
    const paramss = new URLSearchParams(location.search);
    const decodedId = paramss.get("id") || "";
    const decodedName = name ? decodeURIComponent(name) : "";

    if (decodedId && decodedName) {
      return `${decodedId} : ${decodedName}`;
    }

    if (decodedId) return decodedId;
    if (decodedName) return decodedName;

    return "Contact Dossier";
  }, [id, name]);

  const contactDisplayTextName = React.useMemo(() => {
    const paramsss = new URLSearchParams(location.search);
    const decodedId = paramsss.get("id") || "";
    const decodedName = name ? decodeURIComponent(name) : "";

    // If id contains "Contact-" → show NAME
    if (decodedId.includes("Contact-")) {
      return decodedName || decodedId || "Contact Dossier";
    }

    // Otherwise → show ID
    return decodedId || decodedName || "Contact Dossier";
  }, [id, name]);

  const anyValueFilled = (obj) => {
    if (obj == null) return false;
    if (typeof obj === "string") return obj.trim().length > 0;
    if (typeof obj === "number") return true;
    if (Array.isArray(obj)) return obj.some((v) => anyValueFilled(v));
    if (typeof obj === "object") return Object.values(obj).some((v) => anyValueFilled(v));
    return false;
  };

  const getSummaryEntries = (f) => {
    if (!f) return [];

    return [
      {
        type: "basic",
        label: "Level of Influence",
        value: f.levelOfInfluence,
      },
      {
        type: "basic",
        label: "Companies Associated",
        value: f.companiesAssociated,
      },
      {
        type: "basic",
        label: "Desired Relationship Level",
        value: f.desiredRelationshipLevel,
      },
      {
        type: "basic",
        label: "Relationship Notes",
        value: f.relationshipNote,
      },

      {
        type: "employees",
        label: "Employees",
        value: f.employees || [],
      },

      {
        type: "basic",
        label: "Responds Well To",
        value: (f.respondsWellTo || []).join(", "),
      },

      {
        type: "personality",
        label: "Describe Personality",
        value: f.personality || {},
      },

      {
        type: "basic",
        label: "Values",
        value: (f.values || []).join(", "),
      },

      {
        type: "basic",
        label: "Upsell Likelihood",
        value: f.upsellLikelihood != null ? String(f.upsellLikelihood) : "",
      },

      {
        type: "basic",
        label: "Upsell Timeline",
        value: f.upsellTimeline,
      },

      {
        type: "basic",
        label: "Attributes Note",
        value: f.attributesNote,
      },
    ].filter((e) => e.value && (Array.isArray(e.value) ? e.value.length > 0 : true));
  };


  useEffect(() => {
    if (!implId && !id) return;
    const load = async () => {
      setLoadingDossier(true);
      try {
        const response = await getContactDossier(implId || null, id || null);
        const data = response.data;

        let incomingForm = {};
        if (data?.form) {
          incomingForm = { ...data.form };
          if (incomingForm.employees && Array.isArray(incomingForm.employees)) {
            // ok
          } else if (incomingForm.employeeNames && typeof incomingForm.employeeNames === "string") {
            incomingForm.employees = [{ name: incomingForm.employeeNames, knownSinceYear: "", relation: "", note: "" }];
            delete incomingForm.employeeNames;
          } else {
            incomingForm.employees = incomingForm.employees || [];
          }
          delete incomingForm.contactName;
        }

        setForm((s) => ({ ...s, ...incomingForm }));
        setOriginalForm(incomingForm);

        let steps = [];
        if (Array.isArray(data?.saved_steps)) steps = data.saved_steps;
        else if (typeof data?.progress === "number") {
          if (data.progress >= 33) steps.push(0);
          if (data.progress >= 66) steps.push(1);
          if (data.progress === 100) steps.push(2);
        }
        setSavedSteps(steps);
        setProgressPercent(typeof data?.progress === "number" ? data.progress : 0);
        if (data?.dossier_id) setId(data.dossier_id);
        setDossierData(data || null);

        setShowSummary(Boolean(data && data.progress === 100));
      } catch (error) {
        console.error("Failed to load dossier:", error?.response?.status, error?.response?.data || error.message);
        setErr(true);
        setShowSummary(false);
      } finally {
        setLoadingDossier(false);
      }
    };
    load();
  }, [implId, id]);

  const handleGoBack = () => {
    if (window.history.length > 1) navigate(-1);
    else startTransition(() => navigate("/user/findcontact/" + journey_type));
  };

  const handleFormChange = (field) => (ev) => {
    const value = ev?.target?.value ?? ev;
    setForm((s) => ({ ...s, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handlePersonalityChange = (attr) => (ev) => {
    const val = ev?.target?.value ?? ev;
    setForm((s) => ({ ...s, personality: { ...s.personality, [attr]: val } }));
  };

  const toggleArrayValue = (field, value) => {
    setForm((s) => {
      const arr = s[field] || [];
      return arr.includes(value) ? { ...s, [field]: arr.filter((v) => v !== value) } : { ...s, [field]: [...arr, value] };
    });
  };

  const addEmployee = () => {
    setForm((s) => ({ ...s, employees: [...(s.employees || []), { name: "", knownSinceYear: "", relation: "", note: "" }] }));
  };

  const updateEmployeeField = (index, field) => (ev) => {
    const value = ev?.target?.value ?? ev;
    setForm((s) => {
      const employees = [...(s.employees || [])];
      employees[index] = { ...(employees[index] || {}), [field]: value };
      return { ...s, employees };
    });
    setFormErrors((prev) => ({ ...prev, employees: undefined }));
  };

  const removeEmployee = (index) => {
    setForm((s) => {
      const employees = [...(s.employees || [])];
      employees.splice(index, 1);
      return { ...s, employees };
    });
  };

  const validateStep = (currentStep = step) => {
    const e = {};
    if (currentStep === 0) {
      if (!form.levelOfInfluence) e.levelOfInfluence = "Select level of influence";
    }
    setFormErrors(e);
    return Object.keys(e).length === 0;
  };

  const getStepPayload = (stepToSave) => {
    const base = { implId: implId || null, id: id || null };
    if (stepToSave === 0) {
      return { ...base, step: 0, data: { levelOfInfluence: form.levelOfInfluence, companiesAssociated: form.companiesAssociated, desiredRelationshipLevel: form.desiredRelationshipLevel, relationshipNote: form.relationshipNote } };
    }
    if (stepToSave === 1) {
      return { ...base, step: 1, data: { employees: form.employees || [], respondsWellTo: form.respondsWellTo, respondsWellToOther: form.respondsWellToOther } };
    }
    if (stepToSave === 2) {
      return { ...base, step: 2, data: { personality: form.personality, values: form.values, valuesOther: form.valuesOther, upsellLikelihood: form.upsellLikelihood, upsellTimeline: form.upsellTimeline, attributesNote: form.attributesNote } };
    }
    return base;
  };

  const saveStepData = async (stepToSave) => {
    if (!validateStep(stepToSave)) return { ok: false, validationFailed: true };
    setLoadingAction(true);
    try {
      const payload = getStepPayload(stepToSave);
      const response = await postContactDossierStep(payload.implId, payload.id, payload.step, payload.data);
      const data = response.data;
      if (typeof data.progress === "number") setProgressPercent(data.progress);

      if (data?.form) {
        const incoming = { ...data.form };
        if (!incoming.employees && incoming.employeeNames) {
          incoming.employees = [{ name: incoming.employeeNames, knownSinceYear: "", relation: "", note: "" }];
          delete incoming.employeeNames;
        }
        delete incoming.contactName;
        setForm((s) => ({ ...s, ...incoming }));
        setOriginalForm(incoming);
      }

      if (Array.isArray(data?.saved_steps)) setSavedSteps(data.saved_steps);
      else setSavedSteps((prev) => (prev.includes(stepToSave) ? prev : [...prev, stepToSave]));

      if (data?.dossier_id) setId(data.dossier_id);

      setSnack({ open: true, severity: "success", msg: `Step ${stepToSave + 1} saved` });
      return { ok: true, data };
    } catch (error) {
      console.error("Error saving step:", error?.response?.status, error?.response?.data || error.message);
      setSnack({ open: true, severity: "error", msg: `Failed to save step ${stepToSave + 1}` });
      return { ok: false, error };
    } finally {
      setLoadingAction(false);
    }
  };


  const handleNext = async () => {
    if (showSummary && savedSteps.includes(step)) {
      setStep((s) => Math.min(2, s + 1));
      return;
    }

    if (step < 2) {
      const saved = await saveStepData(step);
      if (saved?.validationFailed) return;
      if (!saved?.ok) return;
      setStep((s) => Math.min(2, s + 1));
    } else {
      setStep((s) => Math.min(2, s + 1));
    }
  };
  const handlePrev = () => setStep((s) => Math.max(0, s - 1));

  const handleSubmit = async (ev) => {
    ev && ev.preventDefault();
    if (!validateStep(0)) {
      setStep(0);
      return;
    }
    setFormLoading(true);
    try {
      const response = await postContactDossierFinal(implId || null, id || null, form);
      const data = response.data;

      if (typeof data.progress === "number") setProgressPercent(data.progress);
      if (Array.isArray(data.saved_steps)) setSavedSteps(data.saved_steps);
      if (data?.dossier_id) setId(data.dossier_id);
      if (data?.form) {
        setForm((s) => ({ ...s, ...data.form }));
        setOriginalForm(data.form);
      }

      setShowSummary(true);
      setSnack({ open: true, severity: "success", msg: "Form submitted successfully" });

      setStep(0);
    } catch (error) {
      console.error("Submit error:", error?.response?.status, error?.response?.data || error.message);
      setSnack({ open: true, severity: "error", msg: "Failed to submit form" });
    } finally {
      setFormLoading(false);
    }
  };


  const handleShowSummary = () => setShowSummary(true);
  const handleEdit = () => {
    setForm((s) => ({ ...s, ...(originalForm || {}) }));
    setShowSummary(false);
    setFormErrors({});
  };

  const summaryEntries = getSummaryEntries(form);

  if (loadingDossier) {
    return (
      <>
        <Navbar />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "70vh" }}>
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Loading contact dossier…</Typography>
          </Box>
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box sx={{ padding: "20px", margin: "0 auto", maxWidth: "900px" }}>
        <Card sx={{ textAlign: "center", mt: 2, mb: 1 }}>
          <CardContent>
            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#00A0B2" }}>
              {contactDisplayText}
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {progressPercent}% Complete
              </Typography>
              <LinearProgress variant="determinate" value={progressPercent} sx={{ height: 10, borderRadius: 2 }} />
            </Box>
          </CardContent>
        </Card>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Button variant="contained" onClick={handleGoBack}>Back</Button>
          {savedSteps.length > 0 && !showSummary && (
            <Button variant="outlined" onClick={handleShowSummary}>View Summary</Button>
          )}
          {showSummary && savedSteps.length > 0 && (
            <Button variant="outlined" onClick={handleEdit}>Edit</Button>
          )}
        </Box>

        <Paper elevation={2} sx={{ p: 3, bgcolor: "#fff" }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", color: "#00A0B2" }}>
            Contact Dossier
          </Typography>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Contact Name</Typography>
            <Typography variant="body2">
              {contactDisplayTextName}
            </Typography>
            <Divider sx={{ my: 1 }} />
          </Box>
          {showSummary && summaryEntries.length > 0 ? (
            <Box sx={{ mb: 2 }}>
              {summaryEntries.map((it, idx) => {
                /* BASIC TEXT FIELDS */
                if (it.type === "basic") {
                  return (
                    <Box key={idx} sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {it.label}
                      </Typography>
                      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                        {it.value}
                      </Typography>
                      <Divider sx={{ mt: 1 }} />
                    </Box>
                  );
                }

                /* EMPLOYEES – CARD VIEW */
                if (it.type === "employees") {
                  return (
                    <Box key={idx} sx={{ mb: 3 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                        {it.label}
                      </Typography>

                      {it.value.map((emp, i) => (
                        <Paper
                          key={i}
                          variant="outlined"
                          sx={{ p: 2, mb: 1, bgcolor: "#fafafa" }}
                        >
                          <Typography variant="subtitle2">
                            Employee {i + 1}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Name:</strong> {emp.name || "-"}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Known Since:</strong> {emp.knownSinceYear || "-"}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Relationship:</strong> {emp.relation || "-"}
                          </Typography>
                          {emp.note && (
                            <Typography variant="body2">
                              <strong>Note:</strong> {emp.note}
                            </Typography>
                          )}
                        </Paper>
                      ))}

                      <Divider sx={{ mt: 1 }} />
                    </Box>
                  );
                }

                /* PERSONALITY – BADGE VIEW */
                if (it.type === "personality") {
                  return (
                    <Box key={idx} sx={{ mb: 3 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                        {it.label}
                      </Typography>

                      <Grid container spacing={1}>
                        {Object.entries(it.value)
                          .filter(([, v]) => v)
                          .map(([key, val]) => (
                            <Grid item xs={6} sm={4} key={key}>
                              <Paper
                                variant="outlined"
                                sx={{
                                  p: 1,
                                  textAlign: "center",
                                  bgcolor:
                                    val === "Yes"
                                      ? "#E8F5E9"     // 🌿 light green
                                      : val === "No"
                                      ? "#FDECEA"     // light red
                                      : "#FFF8E1",    // light amber
                                  borderColor:
                                    val === "Yes"
                                      ? "#A5D6A7"
                                      : val === "No"
                                      ? "#F5C6CB"
                                      : "#FFE082",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, color: "#000" }}
                                >
                                  {key}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: 700,
                                    color:
                                      val === "Yes"
                                        ? "#2E7D32"
                                        : val === "No"
                                        ? "#C62828"
                                        : "#FF8F00",
                                  }}
                                >
                                  {val}
                                </Typography>
                              </Paper>
                            </Grid>
                          ))}
                      </Grid>

                      <Divider sx={{ mt: 2 }} />
                    </Box>
                  );
                }

                return null;
              })}
            </Box>
          ) : (
            <>
              {/* Step indicator */}
              <Box sx={{ mb: 2, display: "flex", gap: 1, alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ fontWeight: step === 0 ? 700 : 500, color: step === 0 ? "#1FAFC2" : "inherit" }}>Step 1</Box>
                  {savedSteps.includes(0) && <Typography variant="caption" color="success.main">Saved</Typography>}
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ fontWeight: step === 1 ? 700 : 500, color: step === 1 ? "#1FAFC2" : "inherit" }}>Step 2</Box>
                  {savedSteps.includes(1) && <Typography variant="caption" color="success.main">Saved</Typography>}
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ fontWeight: step === 2 ? 700 : 500, color: step === 2 ? "#1FAFC2" : "inherit" }}>Step 3</Box>
                  {savedSteps.includes(2) && <Typography variant="caption" color="success.main">Saved</Typography>}
                </Box>
              </Box>

              {/* Step 1 */}
              {step === 0 && (
                <Box>
                  <FormLabel sx={{ mt: 2 }}>Level of Influence</FormLabel>
                  <RadioGroup value={form.levelOfInfluence} onChange={handleFormChange("levelOfInfluence")}>
                    {influenceOptions.map((opt) => (
                      <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} />
                    ))}
                  </RadioGroup>
                  {formErrors.levelOfInfluence && <Typography color="error" variant="caption">{formErrors.levelOfInfluence}</Typography>}

                  <Divider sx={{ my: 2 }} />

                  <TextField label="Mention list of Companies Associated with in the past and current (if managing multiple businesses)" value={form.companiesAssociated} onChange={handleFormChange("companiesAssociated")} fullWidth margin="normal" multiline rows={3} />

                  <FormLabel sx={{ mt: 2 }}>Desired Relationship Level</FormLabel>
                  <RadioGroup value={form.desiredRelationshipLevel} onChange={handleFormChange("desiredRelationshipLevel")}>
                    {relationshipLevelOptions.map((opt) => (
                      <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} />
                    ))}
                  </RadioGroup>

                  <TextField
                    label="Relationship Notes (optional)"
                    value={form.relationshipNote}
                    onChange={handleFormChange("relationshipNote")}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={3}
                  />

                  <Box mt={3} display="flex" gap={2}>
                    <Button variant="contained" sx={{ backgroundColor: "#1FAFC2" }} onClick={handleNext} disabled={loadingAction}>
                      {loadingAction ? <CircularProgress size={20} /> : "Next"}
                    </Button>
                    <Button variant="outlined" onClick={() => { setForm(initialFormState); setSavedSteps([]); }}>
                      Clear
                    </Button>
                  </Box>
                </Box>
              )}

              {/* Step 2 */}
              {step === 1 && (
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="subtitle1">Employee(s)</Typography>
                    <Button startIcon={<AddCircleOutlineIcon />} onClick={addEmployee} size="small">Add Employee</Button>
                  </Box>

                  {(form.employees || []).length === 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>No employees added yet. Click "Add Employee" to add names.</Typography>
                  )}

                  {(form.employees || []).map((emp, idx) => (
                    <Paper key={idx} variant="outlined" sx={{ p: 2, mb: 2 }}>
                      <Grid container spacing={2} alignItems="flex-start">
                        <Grid item xs={11}>
                          <TextField label={`Employee Name`} value={emp.name} onChange={updateEmployeeField(idx, "name")} fullWidth margin="dense" />

                          <Grid container spacing={1} sx={{ mt: 1 }}>
                            <Grid item xs={6}>
                              <TextField label="Known since Year" value={emp.knownSinceYear || ""} onChange={updateEmployeeField(idx, "knownSinceYear")} fullWidth margin="dense" placeholder="YYYY" />
                            </Grid>

                            <Grid item xs={6}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel id={`relation-label-${idx}`}>Relation (type)</InputLabel>
                                <Select
                                  labelId={`relation-label-${idx}`}
                                  value={emp.relation || ""}
                                  label="Relation (type)"
                                  onChange={updateEmployeeField(idx, "relation")}
                                  displayEmpty
                                >
                                  <MenuItem value=""></MenuItem>
                                  {relationshipOptionsForEmployee.map((rOpt) => (
                                    <MenuItem key={rOpt} value={rOpt}>{rOpt}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>

                          <TextField label="Note about this relationship" value={emp.note || ""} onChange={updateEmployeeField(idx, "note")} fullWidth margin="dense" multiline rows={2} sx={{ mt: 1 }} />
                        </Grid>

                        <Grid item xs={1} sx={{ display: "flex", alignItems: "start", justifyContent: "end" }}>
                          <IconButton onClick={() => removeEmployee(idx)} aria-label="remove employee" size="large">
                            <DeleteOutlineIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}

                  <FormLabel sx={{ mt: 3 }}>Responds Well To</FormLabel>
                  <FormGroup>
                    {respondsWellToOptions.map((r) => (
                      <FormControlLabel key={r} control={<Checkbox checked={form.respondsWellTo.includes(r)} onChange={() => toggleArrayValue("respondsWellTo", r)} />} label={r} />
                    ))}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                      <FormControlLabel control={<Checkbox checked={!!form.respondsWellToOther} onChange={() => setForm((s) => ({ ...s, respondsWellToOther: s.respondsWellToOther ? "" : "" }))} />} label="Other:" />
                      <TextField size="small" value={form.respondsWellToOther} onChange={handleFormChange("respondsWellToOther")} placeholder="Other" />
                    </Box>
                  </FormGroup>

                  <Box mt={3} display="flex" gap={2}>
                    <Button variant="outlined" onClick={handlePrev}>Previous</Button>
                    <Button variant="contained" sx={{ backgroundColor: "#1FAFC2" }} onClick={handleNext} disabled={loadingAction}>
                      {loadingAction ? <CircularProgress size={20} /> : "Next"}
                    </Button>
                  </Box>
                </Box>
              )}

              {/* Step 3 */}
              {step === 2 && (
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>Describe Personality</Typography>
                  <Box sx={{ border: "1px solid #eee", borderRadius: 1, overflow: "hidden" }}>
                    <Grid container sx={{ bgcolor: "#fafafa", py: 1, px: 2 }}>
                      <Grid item xs={6} />
                      <Grid item xs={2} sx={{ textAlign: "center" }}>Yes</Grid>
                      <Grid item xs={2} sx={{ textAlign: "center" }}>No</Grid>
                      <Grid item xs={2} sx={{ textAlign: "center" }}>Not Sure</Grid>
                    </Grid>

                    {personalityAttributes.map((attr, idx) => (
                      <Grid container key={attr} sx={{ py: 1, px: 2, borderTop: idx === 0 ? "none" : "1px solid #f0f0f0", alignItems: "center" }}>
                        <Grid item xs={6}><Typography>{attr}</Typography></Grid>
                        {["Yes", "No", "Not Sure"].map((opt) => (
                          <Grid item xs={2} sx={{ textAlign: "center" }} key={opt}>
                            <RadioGroup row value={form.personality[attr] || ""} onChange={handlePersonalityChange(attr)}>
                              <FormControlLabel value={opt} control={<Radio />} label="" />
                            </RadioGroup>
                          </Grid>
                        ))}
                      </Grid>
                    ))}
                  </Box>

                  <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>Values / Expects These</Typography>
                  <FormGroup>
                    {valuesList.map((v) => (
                      <FormControlLabel key={v} control={<Checkbox checked={form.values.includes(v)} onChange={() => toggleArrayValue("values", v)} />} label={v} />
                    ))}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                      <FormControlLabel control={<Checkbox checked={!!form.valuesOther} onChange={() => setForm((s) => ({ ...s, valuesOther: s.valuesOther ? "" : "" }))} />} label="Other:" />
                      <TextField size="small" value={form.valuesOther} onChange={handleFormChange("valuesOther")} placeholder="Other value" />
                    </Box>
                  </FormGroup>

                  <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>Upsell Opportunities/Expand Usage</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography>Least Likely</Typography>
                    <Box sx={{ flex: 1, display: "flex", justifyContent: "center", gap: 1 }}>
                      {[1, 2, 3, 4, 5].map((n) => (
                        <FormControlLabel key={n} value={n} control={<Radio checked={form.upsellLikelihood === n} onChange={() => setForm((s) => ({ ...s, upsellLikelihood: n }))} />} label={n} />
                      ))}
                    </Box>
                    <Typography>Highly Likely</Typography>
                  </Box>

                  <FormLabel sx={{ mt: 3 }}>Timeline for Closing Upsell Opportunities</FormLabel>
                  <RadioGroup value={form.upsellTimeline} onChange={handleFormChange("upsellTimeline")}>
                    <FormControlLabel value="Current Quarter" control={<Radio />} label="Current Quarter" />
                    <FormControlLabel value="Next Quarter" control={<Radio />} label="Next Quarter" />
                    <FormControlLabel value="Yet to Pitch" control={<Radio />} label="Yet to Pitch" />
                    <FormControlLabel value="Not Applicable" control={<Radio />} label="Not Applicable" />
                  </RadioGroup>

                  <TextField label="Note About Attributes " value={form.attributesNote} onChange={handleFormChange("attributesNote")} fullWidth margin="normal" multiline rows={3} />

                  <Box mt={3} display="flex" gap={2}>
                    <Button variant="outlined" onClick={handlePrev}>Previous</Button>
                    <Button variant="contained" sx={{ backgroundColor: "#1FAFC2" }} onClick={handleSubmit} disabled={formLoading}>
                      {formLoading ? <CircularProgress size={22} /> : "Submit"}
                    </Button>
                  </Box>
                </Box>
              )}
            </>
          )}
        </Paper>
      </Box>

      <Snackbar open={snack.open} autoHideDuration={4000} onClose={() => setSnack((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "top", horizontal: "center" }} TransitionComponent={Transition}>
        <Alert severity={snack.severity} sx={{ width: "100%" }} onClose={() => setSnack((s) => ({ ...s, open: false }))}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContactDossier;
